import React, { useState, useEffect, Fragment } from 'react';
import PageHeader from '../../components/common/PageHeader';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import * as Icons from '@fortawesome/free-solid-svg-icons';
import { urlApi } from '../../configuracion/serverConfig';
import { headers } from "../../helpers/authSesion";
import cogoToast from 'cogo-toast';
import ButtonIcon from '../../components/common/ButtonIcon';
import XLSX from 'sheetjs-style'

const fecha = new Date().toLocaleDateString();

const AnuladosPage = () => {
  const [data, setData] = useState([]);

  const exportar = () => {
    const table = document.getElementById("tablaExport");
    const wb = XLSX.utils.table_to_book(table);
    /* Export to file (start a download) */
    XLSX.writeFile(wb, "anulados-" + fecha + ".xlsx");
  };

  const getAnulados = () => {
    return fetch(`${urlApi}/informe/anulados`, {
      method: 'GET',
      headers,
    }).then(res => res.json())
      .then(data => data)
      .then(data => {
        return data.status === 0 ? data : { error: true, msg: data.objError.msgError }
      }).catch(err => {
        console.log("Error", err);
        return { error: true, msg: "ERROR" }
      });
  };

  const load = async () => {
    const response = await getAnulados();
    if (response.error) {
      cogoToast.error(response.msg, { position: 'bottom-right', heading: 'Error en la respuesta' });
      return;
    }
    const res = response.objResponse;
    setData(res);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <Fragment>
      <PageHeader
        title="Informe de créditos anulados"
        className="mb-3"
      />

      <ButtonIcon onClick={exportar} icon="file-excel" transform="shrink-3 down-2" color="falcon-default" size="sm">
        Exportar
      </ButtonIcon>

      <table id="tablaExport"
        className="table table-dashboard table-striped table-sm fs--1 border-bottom border-200 mb-0 table-dashboard-th-nowrap">
        <thead>
          <tr>
            <th style={{ textAlign: "center" }} colSpan={11}>INFORME DE CREDITOS ANULADOS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th style={{ textAlign: "center" }}>FECHA DE ANULACION</th>
            <th style={{ textAlign: "center" }}>FECHA DE SOLICITUD</th>
            <th style={{ textAlign: "center" }}>NUMERO DE SOLICITUD</th>
            <th style={{ textAlign: "center" }}>NUMERO DEL CREDITO</th>
            <th style={{ textAlign: "center" }}>LINEA</th>
            <th style={{ textAlign: "center" }}>SUBLINEA</th>
            <th style={{ textAlign: "center" }}>MODALIDAD</th>
            <th style={{ textAlign: "center" }}>PAGADURIA</th>
            <th style={{ textAlign: "center" }}>BENEFICIARIO</th>
            <th style={{ textAlign: "center" }}>MONTO SOLICITADO</th>
            <th style={{ textAlign: "center" }}>ASESOR</th>
          </tr>
          {data.map(i => <tr key={i.prestamo}>
            <td style={{ textAlign: "center" }}>{i.fec_mod}</td>
            <td style={{ textAlign: "center" }}>{i.fecha}</td>
            <td style={{ textAlign: "right" }}>{i.solicitud}</td>
            <td style={{ textAlign: "right" }}>{i.credito}</td>
            <td>{i.nomlinea}</td>
            <td>{i.nomsublinea}</td>
            <td>{i.modalidad}</td>
            <td>{i.nompagaduria}</td>
            <td>{i.nomcliente}</td>
            <td style={{ textAlign: "right" }}>{i.monto.toLocaleString()}</td>
            <td>{i.nomasesor}</td>
          </tr>)}
        </tbody>
      </table>

    </Fragment>
  );
}

export default AnuladosPage;
